import activity from './en-US/activity';
import bonus from './en-US/bonus';
import common from './en-US/common';
import component from './en-US/component';
import finance from './en-US/finance';
import globalHeader from './en-US/globalHeader';
import invitation from './en-US/invitation';
import member from './en-US/member';
import menu from './en-US/menu';
import options from './en-US/options';
import pages from './en-US/pages';
import platform from './en-US/platform';
import pwa from './en-US/pwa';
import report from './en-US/report';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';
import tournament from './en-US/tournament';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...common,
  ...member,
  ...options,
  ...finance,
  ...tournament,
  ...bonus,
  ...invitation,
  ...platform,
  ...activity,
  ...report,
};
